<template>
  <div>
    <div v-if="!this.users" class="d-flex justify-content-center">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <h2>
        <div class="spinner-border text-secondary loader" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </h2>

      <div
        class="googleMap"
        style="width: 100%; height: 620px; margin: 0; padding: 0"
      ></div>
      <form @submit.prevent="fetchData">
        <!-- Bez `required`: Google Maps przenosi ten input do kontrolek mapy (poza <form>),
             a pusty adres oznacza po prostu domyślny punkt wyszukiwania. -->
        <input
          type="text"
          id="my-input-searchbox"
          class="form-control cityInput mapInput"
          placeholder="Adres"
        />
        <div class="buttonsToSearch">
          <select
            name="filtering"
            class="form-control categorySelect mapInput"
            v-model="userType"
          >
            <option
              v-for="option in userTypeOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>

          <select
            v-if="categoryEnabled"
            name="filtering"
            class="form-control categorySelect mapInput"
            v-model="serviceCategoryId"
          >
            <option value="" selected disabled>Kategoria</option>
            <option
              v-for="option in this.serviceCategoriesToSelect"
              :key="option.name"
              :value="option.name"
            >
              {{ option.displayName }}
            </option>
          </select>

          <select
            v-if="
              categoryEnabled &&
              serviceCategoryId &&
              hasSelectedCategorySubCategories
            "
            name="filtering"
            class="form-control categorySelect mapInput"
            v-model="subCategoryId"
          >
            <option value="" selected disabled>Podkategoria</option>
            <option
              v-for="option in subCategories"
              :key="option.id"
              :value="option.id"
            >
              {{ option.display_name }}
            </option>
          </select>

          <select
            name="filtering"
            class="form-control categorySelect mapInput"
            v-model="serviceId"
            v-if="
              categoryEnabled &&
              ((serviceCategoryId && !hasSelectedCategorySubCategories) ||
                (subCategoryId && hasSelectedCategorySubCategories))
            "
          >
            <option value="" selected disabled>Opcja</option>
            <option
              v-for="option in allServices"
              :key="option.id"
              :value="option.id"
            >
              {{ option.display_name }}
            </option>
          </select>

          <input
            required
            type="number"
            min="1"
            v-model="radius"
            class="form-control radiusInput mapInput"
            placeholder="Promień [km]"
          />
          <button
            type="submit"
            class="btn btn-outline-dark searchButton mapInput"
          >
            Szukaj
          </button>
        </div>
      </form>

      <div class="menagment-panel" v-if="this.users">
        <div class="content">
          <div class="pages" v-if="this.users.total_value">
            <span style="color: #000"
              >{{
                this.users.page_number > 1
                  ? (this.users.page_number - 1) * this.users.on_page + 1 + " -"
                  : ""
              }}
              {{
                Math.round(this.users.total_value) / this.users.on_page > 1
                  ? this.users.page_number * this.users.on_page
                  : this.users.total_value
              }}</span
            >
            <span style="font-weight: 400"> na </span>
            <span style="color: #000">{{ this.users.total_value }} </span>
          </div>
          <div class="icons">
            <img
              src="../../icons/arrowLeft.svg"
              @click="previousPage()"
              class="leftArrow"
              v-if="this.users.page_number > 1"
            />
            <img
              src="../../icons/arrowLeftDisabled.svg"
              v-else
              class="disabled-icon leftArrow"
            />

            <img
              src="../../icons/arrowRight.svg"
              @click="nextPage()"
              class="rightArrow"
              v-if="calcPage()"
            />
            <img
              src="../../icons/arrowRightDisabled.svg"
              v-else
              class="disabled-icon rightArrow"
            />
          </div>
        </div>
      </div>
      <button
        class="btn btn-outline-dark"
        @click="downloadUsers"
        v-if="
          users &&
          users.user_profile_service &&
          users.user_profile_service.length > 0
        "
      >
        Pobierz listę użytkowników
      </button>
      <button
        class="btn btn-outline-dark"
        @click="sendMessageToUsers"
        v-if="
          users &&
          users.user_profile_service &&
          users.user_profile_service.length > 0
        "
      >
        Wyślij wiadomość do użytkowników
      </button>
      <div class="">
        <table class="table borderless">
          <thead>
            <tr class="tr-table w-auto">
              <th scope="col">ID użytkownika</th>
              <th scope="col">Rodzaj</th>
              <th scope="col">Utworzono</th>
              <th scope="col">Imię</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Telefon</th>
              <th scope="col">Data urodzenia</th>
              <th scope="col">Pesel</th>
              <th scope="col">Adresy użytkownika</th>
              <th scope="col">Numer konta</th>
              <th scope="col">Weryfikacja numeru konta</th>
              <th scope="col">Status</th>
              <th scope="col">Dystans</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Status pracownika</th>
              <th scope="col">Usługi</th>
              <th scope="col">Płatności</th>
              <th scope="col">Wiadomość</th>
              <th scope="col">Szczegóły</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="data in this.users.user_profile_service"
              :key="data.user_profile.user.id"
            >
              <td>{{ data.user_profile.user.id }}</td>
              <td>{{ data.rodzaj }}</td>
              <td>{{ data.user_profile.user.creation_date }}</td>

              <td>{{ data.user_profile.profile.first_name }}</td>
              <td>{{ data.user_profile.profile.last_name }}</td>
              <td>{{ data.user_profile.user.phone }}</td>
              <td>
                {{
                  data.user_profile.profile.birthdate
                    ? formattedDateWithoutTime(
                        data.user_profile.profile.birthdate
                      )
                    : ""
                }}
              </td>
              <td>{{ data.user_profile.profile.pesel }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#address${data.user_profile.user.id}`"
                >
                  Pokaż
                </button>
              </td>
              <td>{{ data.user_profile.profile.account_number }}</td>
              <td
                v-if="
                  !data.user_profile.profile.payment_verification_status ||
                  data.user_profile.profile.payment_verification_status ===
                    'NOT_INITIALIZED'
                "
              >
                Nie rozpoczęto płatności weryfikacyjnej
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'ACCEPTED'
                "
              >
                Płatność weryfikacyjna zakończona pomyślnie
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'CREATED'
                "
              >
                Płatność weryfikacyjna rozpoczęta, lecz niedokończona
              </td>
              <td
                v-if="
                  data.user_profile.profile.payment_verification_status ===
                  'REJECTED'
                "
              >
                Płatność weryfikacyjna zakończona niepowodzeniem
              </td>

              <td>{{ data.user_profile.profile.profile_status }}</td>
              <td>{{ data.distance }}</td>
              <td>
                <a
                  target="_blank"
                  :href="
                    getUrl() +
                    '/api/profile/photo/' +
                    data.user_profile.profile.file_path
                  "
                >
                  <img
                    class="img-avatar"
                    :src="
                      getUrl() +
                      '/api/profile/photo/' +
                      data.user_profile.profile.file_path
                    "
                  />
                </a>
              </td>

              <!-- :src="requestPhoto(data.user_profile.profile.fileId)" -->
              <td>{{ data.user_profile.profile.employee_status }}</td>

              <td>
                <button
                  v-if="data.user_services && data.user_services.length > 0"
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#userServices${data.user_profile.user.id}`"
                  v-on:click="setCurrentUserServices(data.user_services)"
                >
                  Usługi
                </button>
                <span v-else>Brak usług</span>
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'PaymentsList',
                    query: { search: data.user_profile.user.phone },
                  }"
                >
                  <button type="button" class="btn btn-outline-dark mr-3">
                    Płatności
                  </button>
                </router-link>
              </td>

              <td>
                <router-link
                  :to="{ path: '/chat/' + data.user_profile.user.id }"
                >
                  <button type="button" class="btn btn-outline-dark mr-3">
                    Napisz
                  </button>
                </router-link>
              </td>
              <td>
                <router-link
                  :to="{ path: '/users/id/' + data.user_profile.user.id }"
                >
                  <button
                    type="button"
                    class="btn btn-outline-dark mr-3"
                    @click="getUser(data.user_profile.user.id)"
                  >
                    Przejdź
                  </button>
                </router-link>
              </td>

              <div
                class="modal fade"
                :id="`userServices${data.user_profile.user.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl modal-xl" role="dialog">
                  <div class="modal-content services-modal">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLabel">
                        Usługi użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">ID</th>
                            <th scope="col">Cena</th>
                            <th scope="col">ID usługi</th>
                            <th scope="col">Nazwa</th>
                            <th scope="col">Opis</th>
                            <th scope="col">Pierwszy próg</th>
                            <th scope="col">Drugi próg</th>
                            <th scope="col">Typ</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="item in currentUserServices"
                            v-bind:key="item.id"
                          >
                            <td>{{ item.id }}</td>
                            <td>{{ item.price }}</td>
                            <td>{{ item.service.id }}</td>
                            <td>{{ item.service.display_name }}</td>
                            <td>{{ item.service.description }}</td>
                            <td>{{ item.service.first_threshold }}</td>
                            <td>{{ item.service.second_threshold }}</td>
                            <td>{{ item.service.type }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Adresy użytkownika -->
              <div
                class="modal fade"
                :id="`address${data.user_profile.user.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="address"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="address">
                        Adresy użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <h4>Adresy uwzględnione w wyszukiwaniu</h4>
                      <div style="overflow-x: auto">
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Źródło</th>
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                            <th scope="col">Dystans [km]</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(addr, idx) in data.matched_addresses"
                            :key="idx"
                            :class="{ 'nearest-address': addr.nearest }"
                          >
                            <td>
                              {{ addr.source
                              }}{{ addr.nearest ? " (najbliższy)" : "" }}
                            </td>
                            <td>{{ addr.postcode ? addr.postcode : "Brak" }}</td>
                            <td>{{ addr.city ? addr.city : "Brak" }}</td>
                            <td>{{ addr.street ? addr.street : "Brak" }}</td>
                            <td>{{ addr.number1 ? addr.number1 : "Brak" }}</td>
                            <td>{{ addr.number2 ? addr.number2 : "Brak" }}</td>
                            <td>{{ addr.floor ? addr.floor : "Brak" }}</td>
                            <td>{{ addr.latitude }}</td>
                            <td>{{ addr.longitude }}</td>
                            <td>{{ addr.distance }}</td>
                          </tr>
                          <tr
                            v-if="
                              !data.matched_addresses ||
                              data.matched_addresses.length === 0
                            "
                          >
                            <td colspan="10">Brak adresów ze współrzędnymi</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
        <div class="menagment-panel" v-if="this.users">
          <div class="content">
            <div class="pages" v-if="this.users.total_value">
              <span style="color: #000"
                >{{
                  this.users.page_number > 1
                    ? (this.users.page_number - 1) * this.users.on_page +
                      1 +
                      " -"
                    : ""
                }}
                {{
                  Math.round(this.users.total_value) / this.users.on_page > 1
                    ? this.users.page_number * this.users.on_page
                    : this.users.total_value
                }}</span
              >
              <span style="font-weight: 400"> na </span>
              <span style="color: #000">{{ this.users.total_value }} </span>
            </div>
            <div class="icons">
              <img
                src="../../icons/arrowLeft.svg"
                @click="previousPage()"
                class="leftArrow"
                v-if="this.users.page_number > 1"
              />
              <img
                src="../../icons/arrowLeftDisabled.svg"
                v-else
                class="disabled-icon leftArrow"
              />

              <img
                src="../../icons/arrowRight.svg"
                @click="nextPage()"
                class="rightArrow"
                v-if="calcPage()"
              />
              <img
                src="../../icons/arrowRightDisabled.svg"
                v-else
                class="disabled-icon rightArrow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../shared";
import { URL } from "../../axios";
import gmapsInit from "../../gmaps";

// Punkt startowy wyszukiwania (Łódź), dopóki admin nie wskaże adresu na mapie.
const DEFAULT_COORDINATES = { lat: 51.7592485, lng: 19.4559833 };
const DEFAULT_RADIUS_KM = 30;
// Domyślny margines fitBounds to 45 px z każdej strony - przy podglądzie promienia to za dużo.
const MAP_FIT_PADDING_PX = 16;

export default {
  name: "UsersWithServiceInArea",

  computed: {
    // Kategoria/podkategoria/opcja mają sens (i są brane pod uwagę) tylko dla Wykonawcy i Biznesu.
    categoryEnabled() {
      return ["EMPLOYEE", "BUSINESS"].includes(this.userType);
    },
    hasSelectedCategorySubCategories() {
      const serviceCategoryId = this.serviceCategoryId;
      const serviceCategory = this.serviceCategories.filter(
        (sc) => sc.id === serviceCategoryId
      )[0];
      if (
        serviceCategory &&
        serviceCategory.sub_categories &&
        serviceCategory.sub_categories.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    subCategories() {
      const serviceCategoryId = this.serviceCategoryId;
      const subCategories = this.$store.getters.getAllSubCategories;
      return subCategories.filter(
        (subCategory) => subCategory.service_category.id === serviceCategoryId
      );
    },
    allServices() {
      const serviceCategoryId = this.serviceCategoryId;
      const subCategoryId = this.subCategoryId;
      const services = this.$store.getters.getAllServices;

      if (subCategoryId) {
        return services.filter((service) => {
          if (
            service.sub_category &&
            service.sub_category.id === subCategoryId
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return services.filter((service) => {
          if (
            service.serviceCategoryEntity &&
            service.serviceCategoryEntity.id === serviceCategoryId
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
    users() {
      return this.$store.getters.getUserInSpecifiedArea;
    },
    userServices() {
      return this.$store.getters.getUserServices;
    },
    serviceCategories() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
    phoneNumbersToGroupMessage() {
      return this.$store.getters.getPhoneNumbersToGroupMessages;
    },
  },
  created() {
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    // Obiekty Google Maps trzymamy poza `data` - Vue 2 objęłoby reaktywnością całe ich drzewo.
    this.google = null;
    this.map = null;
    this.searchBox = null;
    this.markers = [];
    this.circles = [];
    this.$store.dispatch("fetchServiceCategoriesWithServices").then(() => {
      this.serviceCategories.forEach((serviceCategory) => {
        this.serviceCategoriesToSelect.push({
          name: serviceCategory.id,
          displayName: serviceCategory.display_name,
        });
      });
      this.serviceCategoriesToSelect.sort((item1, item2) => {
        if (item1.displayName < item2.displayName) return -1;
        if (item1.displayName > item2.displayName) return 1;
        return 0;
      });
    });
    this.$store.dispatch("getAllServices");
    this.$store.dispatch("getAllSubCategories");
  },
  async mounted() {
    const mapElement = this.$el.querySelector(".googleMap");
    if (!mapElement) {
      return;
    }
    const google = await gmapsInit();
    this.google = google;
    const geocoder = new google.maps.Geocoder();
    // Ułamkowy zoom - bez niego fitBounds schodzi do pełnego poziomu w dół i okrąg promienia
    // jest pokazany zauważalnie mniejszy niż pozwala na to rozmiar mapy.
    const map = new google.maps.Map(mapElement, {
      isFractionalZoomEnabled: true,
    });
    this.map = map;
    map.setMapTypeId("roadmap");
    geocoder.geocode({ address: "90-413 Łódź" }, (results, status) => {
      if (status !== "OK" || !results[0]) {
        throw new Error(status);
      }
      map.setCenter(results[0].geometry.location);
      map.fitBounds(results[0].geometry.viewport);

      const input = document.getElementById("my-input-searchbox");
      const searchBox = new google.maps.places.SearchBox(input);
      this.searchBox = searchBox;
      map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(input);
      map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds());
      });
      searchBox.addListener("places_changed", () => this.handlePlacesChanged());
    });
  },

  methods: {
    handlePlacesChanged() {
      const google = this.google;
      const places = this.searchBox.getPlaces();
      if (!places || places.length === 0) {
        return;
      }
      const located = places.filter(
        (place) => place.geometry && place.geometry.location
      );
      this.clearMapOverlays();
      if (located.length === 0) {
        // Bez tego strażnika współrzędne przyjmowały wartość `undefined` i każde kolejne
        // wyszukiwanie kończyło się błędem 400 (wyglądało to jak "przycisk nic nie robi").
        this.$notify({
          group: "error",
          text:
            "Nie udało się ustalić współrzędnych podanego adresu. Wybierz podpowiedź z listy.",
        });
        return;
      }

      const bounds = new google.maps.LatLngBounds();
      located.forEach((place, index) => {
        const marker = new google.maps.Marker({
          map: this.map,
          position: place.geometry.location,
          draggable: true,
        });
        const circle = new google.maps.Circle({
          map: this.map,
          radius: this.radiusInMeters(),
          fillColor: "grey",
        });
        circle.bindTo("center", marker, "position");
        marker.addListener("dragend", (event) => {
          this.setSearchCoordinates(event.latLng.lat(), event.latLng.lng());
        });
        this.markers.push(marker);
        this.circles.push(circle);

        if (index === 0) {
          this.setSearchCoordinates(
            place.geometry.location.lat(),
            place.geometry.location.lng()
          );
        }
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      // Kadrujemy pod okrąg promienia, nie pod zasięg miasta - inaczej przy małym promieniu
      // (np. 5 km) zaznaczenie ginie w widoku całej aglomeracji.
      this.fitToCircles(bounds);
    },
    clearMapOverlays() {
      this.markers.forEach((marker) => marker.setMap(null));
      this.circles.forEach((circle) => circle.setMap(null));
      this.markers = [];
      this.circles = [];
    },
    setSearchCoordinates(lat, lng) {
      if (!isFinite(lat) || !isFinite(lng)) {
        return;
      }
      this.searchCoordinates = { lat, lng };
    },
    // Backend przyjmuje promień jako liczbę całkowitą kilometrów; null = pole puste/niepoprawne.
    parsedRadius() {
      const parsed = parseFloat(String(this.radius).replace(",", "."));
      if (!isFinite(parsed) || parsed <= 0) {
        return null;
      }
      return Math.max(1, Math.round(parsed));
    },
    normalizedRadius() {
      const parsed = this.parsedRadius();
      return parsed === null ? DEFAULT_RADIUS_KM : parsed;
    },
    radiusInMeters() {
      return this.normalizedRadius() * 1000;
    },
    // Podgląd na mapie musi nadążać za polem "Promień" - okręgi powstają raz, przy wyborze adresu.
    updateCirclesRadius() {
      if (this.circles.length === 0 || this.parsedRadius() === null) {
        return;
      }
      const radius = this.radiusInMeters();
      this.circles.forEach((circle) => circle.setRadius(radius));
      this.fitToCircles();
    },
    // Dopasowuje widok do narysowanych okręgów; `fallbackBounds` gdy okręgów jeszcze nie ma.
    fitToCircles(fallbackBounds) {
      const bounds = new this.google.maps.LatLngBounds();
      this.circles.forEach((circle) => {
        const circleBounds = circle.getBounds();
        if (circleBounds) {
          bounds.union(circleBounds);
        }
      });
      if (!bounds.isEmpty()) {
        this.map.fitBounds(bounds, MAP_FIT_PADDING_PX);
      } else if (fallbackBounds && !fallbackBounds.isEmpty()) {
        this.map.fitBounds(fallbackBounds, MAP_FIT_PADDING_PX);
      }
    },
    searchPayload(pageNumber) {
      return {
        serviceCategoryId: this.serviceCategoryId,
        subCategoryId: this.subCategoryId,
        serviceId: this.serviceId,
        userType: this.userType,
        coordinates: this.searchCoordinates
          ? this.searchCoordinates
          : DEFAULT_COORDINATES,
        on_page: this.users ? this.users.on_page : undefined,
        page_number: pageNumber,
        radius: this.normalizedRadius(),
      };
    },
    async runSearch(pageNumber) {
      try {
        await this.$store.dispatch(
          "fetchUsersInSpecifiedArea",
          this.searchPayload(pageNumber)
        );
      } catch (error) {
        this.notifyError(error, "Nie udało się wyszukać użytkowników");
      }
    },
    async sendMessageToUsers() {
      try {
        await this.$store.dispatch(
          "getPhoneNumbersUsersInSpecifiedArea",
          this.searchPayload(1)
        );
      } catch (error) {
        this.notifyError(error, "Nie udało się pobrać numerów telefonów");
        return;
      }
      let routeData = this.$router.resolve({ name: "SendMessage" });
      window.open(routeData.href, "_blank");
    },
    async downloadUsers() {
      try {
        await this.$store.dispatch(
          "downloadProfilesToFileByPhoneNumbers",
          this.searchPayload(1)
        );
      } catch (error) {
        this.notifyError(error, "Nie udało się pobrać listy użytkowników");
      }
    },
    // Nowe wyszukiwanie zawsze zaczyna od pierwszej strony wyników.
    fetchData() {
      this.runSearch(1);
    },
    notifyError(error, fallbackText) {
      const text =
        error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : fallbackText;
      this.$notify({ group: "error", text });
    },
    calcPage() {
      const page_number = this.users.page_number;
      const total_value = this.users.total_value;
      const on_page = this.users.on_page;

      if (total_value / on_page > page_number) {
        return true;
      } else {
        return false;
      }
    },
    nextPage() {
      this.runSearch(this.users.page_number + 1);
    },
    previousPage() {
      this.runSearch(this.users.page_number - 1);
    },
    getUser(id) {
      this.$store.dispatch("fetchUserByPhoneOrUserId", id);
    },
    getUrl() {
      return URL;
    },
    setCurrentUserServices(services) {
      this.currentUserServices = services;
    },
  },

  watch: {
    radius() {
      this.updateCirclesRadius();
    },
    serviceCategoryId() {
      (this.subCategoryId = ""), (this.serviceId = "");
    },
    userType() {
      // Zmiana rodzaju użytkownika czyści filtr kategorii (aktywny tylko dla Wykonawca/Biznes).
      this.serviceCategoryId = "";
      this.subCategoryId = "";
      this.serviceId = "";
    },
  },

  data() {
    return {
      currentUserServices: [],
      firstName: "",
      lastName: "",
      selectedService: "",
      userId: "",
      searchParam: "",
      serviceCategoriesToSelect: [],
      serviceCategoryId: "",
      radius: DEFAULT_RADIUS_KM,
      // Środek wyszukiwania - null oznacza domyślny punkt (DEFAULT_COORDINATES).
      searchCoordinates: null,
      subCategoryId: "",
      serviceId: "",
      userType: "",
      userTypeOptions: [
        { value: "", label: "Wszystkie" },
        { value: "EMPLOYEE", label: "Wykonawca" },
        { value: "CUSTOMER", label: "Klient" },
        { value: "BUSINESS", label: "Biznes" },
      ],
    };
  },
};
</script>

<style scoped>
.modal-table td {
  background-color: white;
}
.modal-table tr.nearest-address td {
  background-color: #eaf7ea;
  font-weight: 700;
}

.modal-dialog modal-xl div {
  background-color: white;
}
.services-modal {
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
}
.proposition-modal {
  width: 550px;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
}
#map * {
  overflow: visible;
}
.menagment-panel .disabled-icon {
  color: rgba(182, 182, 182, 0.571);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.pages {
  font-size: 14px;
  font-weight: bold;
}
.cityInput {
  width: 400px;
  margin: 0 auto;
  margin-bottom: 5px;
  border: 1px solid rgb(80, 78, 78);
}
.categorySelect {
  margin-top: 10px !important;
  width: 400px;
  margin: 0 auto;
}
.searchButton {
  margin-right: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.searchButton:hover {
  margin-right: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buttonsToSearch {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.radiusInput {
  margin: 0 auto;
}
.mapInput {
  margin-top: 20px;
  width: 400px;
  border: 2px solid rgb(87, 84, 84);
  border-radius: 10px;
  -webkit-box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.75);
}
.mapInput:hover {
  margin-top: 20px;
}

.icons img {
  height: 30px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
}
.rightArrow {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.leftArrow {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.content {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.pages {
  font-size: 14px;
  font-weight: bold;
}
</style>
